import axios from 'axios';

export const createMessage = async (data) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/messages`;
    
    // L'intercepteur global ajoutera automatiquement le token
    return axios.post(ApiUrl, data).then((response) => response.data);
}

export const createMessagePicture = async (formData) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/messages/picture`;
    
    // L'intercepteur global ajoutera automatiquement le token
    return axios.post(ApiUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => response.data);
}

export const updateMessageReadStatus = async (messageId, isRead) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/messages/${messageId}`;
    const data = { isRead: isRead };
    
    if (!process.env.REACT_APP_PUBLIC_API) {
        console.error('URL de l\'API non configurée');
        throw new Error('URL de l\'API non configurée');
    }

    // L'intercepteur global ajoutera automatiquement le token et gérera les erreurs 401
    const response = await axios.put(ApiUrl, data);
    
    // Vérifier que la mise à jour a bien été effectuée
    if (response.data && response.data.isRead === true) {

    } else {

    }
    
    return response.data;
}

export const deleteMessage = async (messageId) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/messages/${messageId}`;
    
    if (!process.env.REACT_APP_PUBLIC_API) {
        console.error('URL de l\'API non configurée');
        throw new Error('URL de l\'API non configurée');
    }

    // L'intercepteur global ajoutera automatiquement le token et gérera les erreurs 401
    const response = await axios.delete(ApiUrl);
    
    return response.data;
}